export function GetMockCaseWithAllEntities() {
  return {
    applicants: [
      {
        id: 847,
        jmCaseId: 424,
        applicantName: "Stephen Flynn",
        applicantEmail: "Stephenflynn5278@hotmail.co.uk",
        applicantPhone1: "07872 599178",
        applicantPhone2: "07872 599178",
        applicantAddress: "37 Fraser Drive Bramshall UTTOXETER ST14 5EH",
        applicantTown: "Uttoxeter ",
        applicantCounty: null,
        applicantPostcode: "ST14 5EH",
        employmentStatusId: 36,
        otherPropertyOwned: 1,
        willPropBeSold: 1,
      },
      {
        id: 848,
        jmCaseId: 424,
        applicantName: "Jessica lowire ",
        applicantEmail: null,
        applicantPhone1: null,
        applicantPhone2: null,
        applicantAddress: "41 harvey place ",
        applicantTown: null,
        applicantCounty: null,
        applicantPostcode: "st14 4aj",
        employmentStatusId: 36,
        otherPropertyOwned: 0,
        willPropBeSold: 0,
      },
    ],
    caseNotes: [
      {
        noteUser: {
          employeeId: "1923059",
          name: "Adam Faulkner",
        },
        id: 1,
        dateAdded: "2022-05-03T15:40:01.3153535",
        noteText:
          "client has own broker and AIP in place. doesnt wish to proceed with us",
        caseId: 424,
        addedByUserId: 14,
        isDeleted: 0,
        deletedDate: "0001-01-01T00:00:00",
      },
    ],
    queries: [],
    milestones: [
      {
        milestoneUser: {
          employeeId: "1924537",
          name: "Eri Nani",
        },
        notes: [],
        id: 3082,
        milestoneTypeId: 18,
        caseId: 424,
        updatedByUserId: 96,
        dateUpdated: "2022-05-03T13:57:08.1913386",
        milestoneDate: "0001-01-01T00:00:00",
        milestoneData:
          '{"qualificationStatus":2,"qualifiedDate":"2022-05-02T23:00:00.000Z","caseProceedable":1,"caseProceedableYesWhy":"Proceeding with JMNB","sharedOwnershipPurchase":1,"maximumShare":"50","isHTB":0,"standardPurchase":1,"qualifiedReserve":1,"isMilestoneComplete":1}',
        sendEmail: 1,
        updateCaseStatus: 1,
        offerExpiryDate: "0001-01-01T00:00:00",
      },
      {
        milestoneUser: {
          employeeId: "1923210",
          name: "Laura Jones",
        },
        notes: [],
        id: 3083,
        milestoneTypeId: 19,
        caseId: 424,
        updatedByUserId: 54,
        dateUpdated: "0001-01-01T00:00:00",
        milestoneDate: "0001-01-01T00:00:00",
        milestoneData: null,
        sendEmail: 0,
        updateCaseStatus: 0,
        offerExpiryDate: "0001-01-01T00:00:00",
      },
      {
        milestoneUser: {
          employeeId: "1923210",
          name: "Laura Jones",
        },
        notes: [],
        id: 3084,
        milestoneTypeId: 20,
        caseId: 424,
        updatedByUserId: 54,
        dateUpdated: "0001-01-01T00:00:00",
        milestoneDate: "0001-01-01T00:00:00",
        milestoneData: null,
        sendEmail: 0,
        updateCaseStatus: 0,
        offerExpiryDate: "0001-01-01T00:00:00",
      },
      {
        milestoneUser: {
          employeeId: "1923210",
          name: "Laura Jones",
        },
        notes: [],
        id: 3085,
        milestoneTypeId: 21,
        caseId: 424,
        updatedByUserId: 54,
        dateUpdated: "0001-01-01T00:00:00",
        milestoneDate: "0001-01-01T00:00:00",
        milestoneData: null,
        sendEmail: 0,
        updateCaseStatus: 0,
        offerExpiryDate: "0001-01-01T00:00:00",
      },
      {
        milestoneUser: {
          employeeId: "1923210",
          name: "Laura Jones",
        },
        notes: [],
        id: 3086,
        milestoneTypeId: 22,
        caseId: 424,
        updatedByUserId: 54,
        dateUpdated: "0001-01-01T00:00:00",
        milestoneDate: "0001-01-01T00:00:00",
        milestoneData: null,
        sendEmail: 0,
        updateCaseStatus: 0,
        offerExpiryDate: "0001-01-01T00:00:00",
      },
      {
        milestoneUser: {
          employeeId: "1923210",
          name: "Laura Jones",
        },
        notes: [],
        id: 3087,
        milestoneTypeId: 23,
        caseId: 424,
        updatedByUserId: 54,
        dateUpdated: "0001-01-01T00:00:00",
        milestoneDate: "0001-01-01T00:00:00",
        milestoneData: null,
        sendEmail: 0,
        updateCaseStatus: 0,
        offerExpiryDate: "0001-01-01T00:00:00",
      },
      {
        milestoneUser: {
          employeeId: "1923210",
          name: "Laura Jones",
        },
        notes: [],
        id: 3088,
        milestoneTypeId: 24,
        caseId: 424,
        updatedByUserId: 54,
        dateUpdated: "0001-01-01T00:00:00",
        milestoneDate: "0001-01-01T00:00:00",
        milestoneData: null,
        sendEmail: 0,
        updateCaseStatus: 0,
        offerExpiryDate: "0001-01-01T00:00:00",
      },
      {
        milestoneUser: {
          employeeId: "1923210",
          name: "Laura Jones",
        },
        notes: [],
        id: 3089,
        milestoneTypeId: 74,
        caseId: 424,
        updatedByUserId: 54,
        dateUpdated: "0001-01-01T00:00:00",
        milestoneDate: "0001-01-01T00:00:00",
        milestoneData: null,
        sendEmail: 0,
        updateCaseStatus: 0,
        offerExpiryDate: "0001-01-01T00:00:00",
      },
      {
        milestoneUser: {
          employeeId: "1923210",
          name: "Laura Jones",
        },
        notes: [],
        id: 3090,
        milestoneTypeId: 75,
        caseId: 424,
        updatedByUserId: 54,
        dateUpdated: "0001-01-01T00:00:00",
        milestoneDate: "0001-01-01T00:00:00",
        milestoneData: null,
        sendEmail: 0,
        updateCaseStatus: 0,
        offerExpiryDate: "0001-01-01T00:00:00",
      },
      {
        milestoneUser: {
          employeeId: "1923210",
          name: "Laura Jones",
        },
        notes: [],
        id: 3091,
        milestoneTypeId: 76,
        caseId: 424,
        updatedByUserId: 54,
        dateUpdated: "0001-01-01T00:00:00",
        milestoneDate: "0001-01-01T00:00:00",
        milestoneData: null,
        sendEmail: 0,
        updateCaseStatus: 0,
        offerExpiryDate: "0001-01-01T00:00:00",
      },
      {
        milestoneUser: {
          employeeId: "1923210",
          name: "Laura Jones",
        },
        notes: [],
        id: 3092,
        milestoneTypeId: 77,
        caseId: 424,
        updatedByUserId: 54,
        dateUpdated: "0001-01-01T00:00:00",
        milestoneDate: "0001-01-01T00:00:00",
        milestoneData: null,
        sendEmail: 0,
        updateCaseStatus: 0,
        offerExpiryDate: "0001-01-01T00:00:00",
      },
    ],
    developer: {
      id: 1,
      name: "Sage - L&NH",
      contactName: "Alexander Scott",
      contactEmail: "Alexander.Scott@justmortgages.co.uk",
      contactAddress: null,
      contactTown: null,
      contactCounty: null,
      contactPostcode: null,
      primaryPhone: "07587038943 ",
      secondaryPhone: null,
      isDeleted: 0,
      createdDate: "2022-01-31T13:56:25.1842422",
      updatedDate: "2022-06-09T19:38:25.3604659",
      developerCode: "SAG",
      addedByUserId: 4,
      updatedByUserId: 47,
    },
    development: {
      id: 0,
      name: null,
      addedByUserId: 0,
      address: null,
      town: null,
      postcode: null,
      county: null,
      developerId: 0,
      emailAddress: null,
      phoneNumber: null,
      mainContactName: null,
      podAllocationId: 0,
      generalInfo: null,
      unitTypes: null,
      units: 0,
      createdDate: "0001-01-01T00:00:00",
      updatedDate: "0001-01-01T00:00:00",
      isDeleted: 0,
    },
    administrator: null,
    advisor: {
      employeeId: "1923059",
      name: "Adam Faulkner",
    },
    manager: {
      employeeId: "1908806",
      name: "Sam Bowyer",
    },
    referralUser: {
      employeeId: "1923210",
      name: "Laura Jones",
    },
    id: 424,
    caseRef: "SAG424",
    referredById: 54,
    caseStatusId: 65,
    developmentId: 4,
    purchasePrice: 290000,
    plotNumber: "27",
    htb: 0,
    cashBuyer: 0,
    so: 1,
    keyNotes: "fully qualified ",
    dateOfReferral: "2022-05-03T10:13:34.0777445",
    offerExpiryDate: "0001-01-01T00:00:00",
    updatedDate: "2022-05-03T14:56:02.9779412",
    isDeleted: 0,
    advisorId: 14,
    propertyStatusId: 40,
    depositLevel: 29000,
    serviceCharge: 70,
    minPercShareAvailable: "25",
    housingAssociation: "sage",
    financialDetailsId: 243,
    closedDate: "2022-05-03T15:40:14.8815531",
    isClosed: 1,
    administratorId: null,
    lnhManagerId: 28,
  };
}
